import { isClient } from '@/utils/isClient';
import type {
  AnalyticsWriter,
  EventProperties,
} from '@soluto-private/analytics-core';

export interface GoogleAnalyticsProps {
  channel: string;
  partner: string;
  browserId: string;
}

export class GoogleAnalyticsWriter implements AnalyticsWriter {
  // Potential channel values: 'd2c', 'affiliate', 'partner'
  #channel: string;
  #sessionId: string | undefined;
  #userBrowserId: string;
  #partner: string;
  #traits: Record<string, any> | undefined;

  constructor({ channel, partner, browserId }: GoogleAnalyticsProps) {
    if (!channel || !partner) {
      throw new Error('Cannot initialize Google Analytics');
    }
    this.#channel = channel;
    this.#partner = partner;
    this.#userBrowserId = browserId;
  }
  /*
    identify(userId: string, traits?: Record<string, any> | undefined)
    Google Analytics does not support identify directly, so we just store the traits for use in the track calls.
  */
  public async identify(
    userId: string,
    traits?: Record<string, any> | undefined,
  ): Promise<void> {
    this.#traits = traits;
    this.#sessionId = userId;
  }
  /*
    track(eventName: string, data: EventProperties)
    Google Analytics does not support track directly, so we push the event data to the dataLayer for consumption by the
    Google Tag Manager Container that is injected into the head of the rendered html.
  */
  public async track(eventName: string, data: EventProperties): Promise<void> {
    if (isClient()) {
      window.dataLayer?.push({
        channel: this.#channel,
        sessionId: this.#sessionId,
        userBrowserId: this.#userBrowserId,
        event: eventName,
        partner: data.MetaData?.Client || this.#partner,
        userTraits: this.#traits,
        data,
      });
    }
  }
}
